import { API_URL } from "constants/index";
import { fetchWithAuth } from "shared/api/fetch-with-auth";
import { FileLogStatus } from "shared/types/file";
import { UnitDTO } from "shared/types/unit";

/**
 * Calculates dot values for dangerous materials information specifically for a unit
 * @param unit The unit to calculate dangerous materials dot values for
 * @param session The current session for authentication
 * @returns Object with dot values for red, orange, green, and transparent categories
 */
export const calculateDangerousMaterialsForUnit = async (unit: UnitDTO, session: any) => {
    let dotValues: any = {
        red: { count: 0, labels: [] },
        orange: { count: 0, labels: [] },
        green: { count: 0, labels: [] },
        transparent: { count: 0, labels: [] },
    };

    try {
        // Fetch asbestos certificate file logs for the unit
        const queryParams = new URLSearchParams();
        if (unit?.id) {
            queryParams.append('unitId', unit.id);
        }

        const labels = [
            "Asbestattest unit",
        ];
        queryParams.append('labels', labels.join(','));

        const response = await fetchWithAuth(
            `${API_URL}/file/get-file-logs?${queryParams.toString()}`,
            { method: 'GET' },
            session
        );
        const fileLogs = await response.json();
        
        // Filter and sort by date to get the most recent certificate
        const asbestosCertificateLogs = fileLogs.filter((log: any) =>
            log.label.includes("Asbestattest unit")
        ).sort((a: any, b: any) => new Date(b.documentDate).getTime() - new Date(a.documentDate).getTime());

        if (!asbestosCertificateLogs.length) {
            // No certificate found
            dotValues.transparent.count++;
            dotValues.transparent.labels.push("Geen asbestattest aanwezig");
        } else {
            // Evaluate the most recent certificate
            const latestCertificate = asbestosCertificateLogs[0];
            
            if (latestCertificate.status === FileLogStatus.OK) {
                dotValues.green.count++;
                dotValues.green.labels.push("Geldig asbestattest aanwezig");
            } else if (latestCertificate.status === FileLogStatus.OK_WITH_REMARKS) {
                dotValues.orange.count++;
                dotValues.orange.labels.push("Asbestattest aanwezig met opmerkingen");
            } else if (latestCertificate.status === FileLogStatus.NOT_OK) {
                dotValues.red.count++;
                dotValues.red.labels.push("Ongeldig asbestattest");
            } else if (latestCertificate.status === FileLogStatus.NOT_REQUIRED) {
                dotValues.green.count++;
                dotValues.green.labels.push("Asbestattest niet vereist");
            } else {
                // Status is unknown/undefined
                dotValues.transparent.count++;
                dotValues.transparent.labels.push("Asbestattest aanwezig, maar status onbekend");
            }
        }
    } catch (error) {
        console.error('Error fetching asbestos certificate logs for unit:', error);
    }

    return dotValues;
};
